import { Outlet, createFileRoute } from '@tanstack/react-router'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

// Layout route para /dashboard/$dashboardId/oportunidades
// Este arquivo (route.tsx) serve como layout que envolve todas as rotas filhas
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/oportunidades',
)({
  component: function OportunidadesLayoutRoute() {
    const { dashboardId } = Route.useParams()
    
    return (
      <RequireModule module={MODULES.OPORTUNIDADES} dashboardId={dashboardId}>
        <Outlet />
      </RequireModule>
    )
  },
})
